<template>
  <div>
    <div class="buttons">
      <button
        v-bind:class="!backButton ? 'disableButton' : 'enableButton'"
        :disabled="!backButton"
        @click="onClickBack"
      >
        Назад
      </button>
      <button
        class="button-remarks"
        v-tooltip.top-center="remarkMsg"
        v-if="remarkMsg != null && remarkMsg.length > 0"
      >
        Показать замечания
      </button>
      <button
        id="next-button"
        v-bind:class="!nextButton ? 'disableButton' : 'enableButton'"
        v-tooltip.top-center="msg"
        @click="onClickNext"
      >
        {{ nextButtonLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterButtons",
  props: {
    pageInfo: {},
    nextButtonLabel: {
      type: String,
      default: "Далее",
    },
    msg: String,
    backButton: Boolean,
    nextButton: Boolean,
    remarkMsg: String,
  },
  methods: {
    onClickBack() {
      this.$emit("on_click_back");
    },
    onClickNext() {
      if (this.nextButton) this.$emit("on_click_next");
    },
  },
};
</script>

<style scoped>
button {
  font-size: 20px;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  border: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 20px;
  outline: none;
  color: white;
  cursor: pointer;
}
.buttons {
  background: transparent;
}
.disableButton {
  background-color: #85b0f8;
}
.enableButton {
  background-color: #06569b;
}
.button-remarks {
  color: black;
  background-color: transparent;
  border: 1px solid rgb(236, 95, 95);
}
</style>
